export default __webpack_public_path__ + "static/media/sh_5.ca5be341.png";